import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import whatsappLogo from './photos/whatsapp.png';
import Logo from './photos/Logo black1.png';
import flagEn from './photos/Eng.png';
import flagTr from './photos/Tr.png';
import flagAr from './photos/Ar.png'; 
import flagRu from './photos/Ru.png'; 
import { FaBars, FaTimes } from 'react-icons/fa'; // Import icons
import './Navbar.css';

function Navbar() {
  const { language, changeLanguage, translations } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to handle the menu toggle

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/905387017377', '_blank'); // Replace with your number
  };

  return (
    <div className="Navbar">
      <div className="Logo">
        <img src={Logo} alt="Logo" />
      </div>
      <div className="menu-icon" onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      <div className={`Links ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><a href="#Hizmetler" onClick={toggleMenu}>{translations[language].services}</a></li>
          <li><a href="#Hakkimizda" onClick={toggleMenu}>{translations[language].aboutUs}</a></li>
          <li><a href="#iletisim" onClick={toggleMenu}>{translations[language].contact}</a></li>
          <li><a href="#Galeri" onClick={toggleMenu}>{translations[language].gallery}</a></li>
        </ul>
        <div className="lang-flags-container">
          <div className="lang-flags">
            <img src={flagTr} alt="Türkçe" onClick={() => { changeLanguage('tr'); toggleMenu(); }} />
            <img src={flagEn} alt="English" onClick={() => { changeLanguage('en'); toggleMenu(); }} />
            <img src={flagAr} alt="Arabic" onClick={() => { changeLanguage('ar'); toggleMenu(); }} />
            <img src={flagRu} alt="Russian" onClick={() => { changeLanguage('ru'); toggleMenu(); }} />
          </div>
        </div>
        <button className="whatsapp-button" onClick={() => { handleWhatsAppClick(); toggleMenu(); }}>
          <img src={whatsappLogo} alt="WhatsApp" />
          {translations[language].whatsapp}
        </button>
      </div>
    </div>
  );
}

export default Navbar;
